import React, { useState, useEffect, useContext} from 'react';
import * as S from './styles';
import { Redirect } from 'react-router-dom';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import Cookies from 'js-cookie';

//---------COMPONENTES----------------------
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';
import BarraLateral from '../../componentes/BarraLateral/index';

import Modalcliente from '../../componentes/Modal/ModalCliente';
import ModalVeiculo from '../../componentes/Modal/ModalVeiculo';
import ModalBanco from '../../componentes/Modal/ModalBanco';
import ModalOrcamento from '../../componentes/Modal/ModalOrcamento';
import { ModalUsuario } from '../../componentes/Modal/ModalUsuario';

import ListaClientes from '../../componentes/ListarPesquisas/ListaCliente';
import { ListaVeiculos } from '../../componentes/ListarPesquisas/ListaVeiculo';
import { ListaEventos } from '../../componentes/ListarPesquisas/ListaEvento';
import { ListaBanco } from '../../componentes/ListarPesquisas/ListaBanco';

import PesquisaOrcanento from '../../componentes/Pesquisas/pesqOrcamento';
import { PesquisaPadrao } from '../../componentes/Pesquisas/PesquisaPadrao';

import LoadingContent from '../../componentes/loading/loading';
import { Functions, FunctModal } from '../../componentes/Functions';

import { CameraWeb } from '../../componentes/Cadastro/CameraWeb';

import {Load_Bola} from '../../componentes/loading/Func_Load';

//---------SERVICES--------------------------
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { ApiUsuario } from '../../services/FiltrosApi/logado';
import Usuario from './Usuario';

// ----------ADD----------------------
import { EVENTOS } from './EVENTOS';
// ------------------------------------------
function Add() {
    const { state, dispatch } = useContext(Context);
    const { cliente, logado } = state.cliente;
    const { veiculo } = state.veiculo;
    const { evento } = state.evento;

    const { parametroInit, displayModal, playmodal, listaPesquisa, playLista } = state.parametros;
    const {
        pesquisaIdVeiculo,
        loading,
    } = parametroInit;

    const { id_Evento, codEvenBD } = evento;
    const { listaCliente, listaEvento } = listaPesquisa;

    const [idPag, setIdPag] = useState('');
    const [Statusconcluido, setCCConcluido] = useState('');
    const [somaValorPago, setSomaValorPago] = useState('')
    const [checkPag, setcheckPag] = useState(false);
    const [newValor_produtos, editValorProdutos] = useState('');
    const [newValor_servico, editValorServicos] = useState('');
    const [TotalEven, setTotalEven] = useState('');

    const [alertDelete, setAletDelete] = useState(false);
    const [newStatus, setNewStatus] = useState('');
    const [refDelete, setRefDelet] = useState('');

    const { LogUsuario } = ApiUsuario();
    const { Play_Modal_Add, EditarSelect, ExcluirEste } = Functions({
        alertDelete, newStatus, refDelete, setNewStatus, setAletDelete,
    });
    const { FecharModal } = FunctModal();

    const { PesqVeiculoPlaca, PesqVeiXcliente, pesqIDveiculo } = Api_Veiculos();
    const { BuscaTodosClientes, BuscaTodosUsuarios, pesqidcliente } = Api_Clientes();
    const { PesqEventoCod} = ApiEvento();

    // --------------
    const token = Cookies.get('token');

    useEffect(() => {
        if (token) {
            LogUsuario(token);
        } else {
            dispatch({
                type: 'set_logado',
                payload: { ...logado, conectado: false }
            });
        }
    }, [token]);

    //--------------Pesquisar cliente por CPF-------
    async function pesqclienteCpf(cpf) {
        dispatch({
            type: 'set_limparcliente'
        });

        dispatch({
            type: 'set_veiculo',
            payload: { ...veiculo, id: '' }
        });
        dispatch({
            type: 'set_playLista',
            payload: { ...playLista, playListaClie: false, playListaVeic: false }
        });
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalCliente: false,
                playModalVeiculo: false,
                playModalBanco: false
            }
        });

        if (cpf) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: true }
            });

            await api.get(`cliente/filtrar/${cpf}`)
                .then(res => {
                    const buscar = res.data;
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaCliente: buscar }
                    });
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: {
                            ...parametroInit,
                            loading: false,
                            bcarBanco: false,
                            buscarVeic: false,
                        }
                    });
                    dispatch({
                        type: 'set_playLista',
                        payload: { playListaClie: true }
                    });
                })
        } else {
            BuscaTodosClientes();
        }
    };

    //-----------------------------------------------
    useEffect(() => {
        if (pesquisaIdVeiculo) {
            pesqIDveiculo();
        }
    }, [pesquisaIdVeiculo])


    //-Atualizar Evento - Colocar como Pago "Statusconcluido" ou Aberto---------
    async function AtualizarConcluido() {
        if (somaValorPago >= TotalEven && Statusconcluido === false) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: true,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Pago!');
                }
            })
        };
        //--------
        if (somaValorPago < TotalEven && Statusconcluido === true) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: false,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Esta em Abeto!');
                }
            })
        };
    };

    //------------------------------------
    useEffect(() => {
        AtualizarConcluido()
    }, [somaValorPago && TotalEven && Statusconcluido])

    // ------------------------------
    useEffect(() => {
        pesqidcliente();
    }, [cliente.id_Cliente]);

    // ---------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
                playModalDetalhesEven: false,
            }
        });
    }, [parametroInit.filtroPlaca])

    //------------Somar o Total-----------------
    const [Total, setTotal] = useState(0);
    let tt = parseFloat(newValor_servico) + parseFloat(newValor_produtos);

    useEffect(() => {
        if (tt) {
            setTotal(tt)
        }
    }, [tt])

    //-------------------Gerar Codigos-----------
    useEffect(() => {
        let inic = (1);
        let codinic = veiculo.placa + '-0' + inic;
        const regex = new RegExp(codinic, 'i'); // Expresao regular
        let verific = regex.test(codEvenBD) // verificar se ja existe este codigo no banco de dados
        //--------
        if (verific) { // se cod for igual, gerar novo
            for (; verific; inic++) {
                let codNovo = veiculo.placa + '-0' + inic
                const regex = new RegExp(codNovo, 'i');
                let verific = regex.test(codEvenBD)

                if (!verific) {
                    dispatch({
                        type: 'set_Evento',
                        payload: { ...evento, codEvento: codNovo }
                    });
                    break
                }
            };
        } else {
            if (veiculo.placa) {
                dispatch({
                    type: 'set_Evento',
                    payload: { ...evento, codEvento: codinic }
                });
            }
        }
    }, [codEvenBD && veiculo.placa]);

    //---------------------------------------------------
    function FecharAlerte() {
        setAletDelete(false)
    };
    // ---------------------------------------------------

    useEffect(() => {
        if (parametroInit.NaoLocalizado) {
            dispatch({
                type: 'SET_PLAYMODAL',
                payload: { ...playmodal, playModalVeiculo: true }
            });
        };

    }, [parametroInit.NaoLocalizado]);
    // --------------------------------------

    //###################################################################################################
    return (
        <S.App
        fundoBloque={
            alertDelete ||
            (playmodal.playModalEven && !parametroInit.detalhesLista) ||
            playmodal.playModalEvenPlaca ||
            playmodal.playModalUsuario ||
            playmodal.playModalCliente ||
            playmodal.playModalVeiculo || 
            parametroInit.NaoLocalizado
        }>
            {!token && <Redirect to='/login' />}
            <div className='fundoBloque' />
            <Header playLogo={true} />
            <S.body>
                <BarraLateral />

                <S.body2>
                    <Load_Bola />
                    
                    {/* {
                    <div style={{display:"flex", marginTop:"55px", width:"100vw", justifyContent:"center"}}>
                        <span style={{color: '#d8d8d8'}}> Seja forte e corajoso! josué 1:9</span>
                    </div>
                    }  */}
                   

                    {/* --------------CLIENTE--------------- */}
                    {displayModal.clienteDisplay &&
                        <S.containerPesq>
                            <PesquisaPadrao
                                refPlaca={true}
                                playBotao={true}
                                Lupa={true}
                                titulo="Buscar Cliente:"
                                placeholder="cpf"
                                nomeBotao="Novo Cliente"
                                Pesquisar={pesqclienteCpf}
                                playModal_Add={Play_Modal_Add}
                                PesqDentroModal={false}
                                PesquisarData={() => { }}
                            />
                        </S.containerPesq>
                    }

                    {/* --------------VEICULO--------------- */}
                    {displayModal.veiculosDisplay &&
                        <S.containerPesq>
                            <PesquisaPadrao
                                refPlaca={true}
                                playBotao={true}
                                Lupa={true}
                                titulo="Buscar Veiculo:"
                                placeholder="placa"
                                nomeBotao="Novo Veiculo"
                                Pesquisar={PesqVeiculoPlaca}
                                playModal_Add={Play_Modal_Add}
                                PesqDentroModal={false}
                                PesquisarData={() => { }}
                            />
                        </S.containerPesq>
                    }

                    {/* --------------ORÇAMENTO Pesquisa---------*/}
                    {displayModal.orcamentoDisplay &&
                        <S.containerPesq>
                            <PesquisaOrcanento
                                Lupa={true}
                                PesqEventoCod={PesqEventoCod}
                                PesqDentroModal={false}
                            />
                        </S.containerPesq>
                    }
                    

                    {/*---------CLIENTE-------------*/}
                    {displayModal.clienteDisplay &&
                        <S.ContainerLista>
                            <S.bodyLista>
                                {loading && !playmodal.playModalCliente &&
                                    <S.bodyresult>
                                        <LoadingContent />
                                    </S.bodyresult>
                                }

                                {!loading &&
                                    <div style={{ 'display': "flex", 'flexDirection': 'column' }} >
                                        <ListaClientes
                                            listaBusca={listaCliente}
                                            setAletDelete={setAletDelete}
                                            setNewStatus={setNewStatus}
                                            alertDelete={alertDelete}
                                            pesqclienteCpf={pesqclienteCpf}
                                            setRefDelet={setRefDelet}
                                            FecharAlerte={FecharAlerte}
                                            ExcluirEste={ExcluirEste}
                                        />
                                        {playmodal.playModalCliente &&
                                            <Modalcliente
                                                FecharModal={FecharModal}
                                                EditarSelect={EditarSelect}
                                                pesqclienteCpf={pesqclienteCpf}
                                                Lupa={true}
                                            />
                                        }
                                    </div>
                                }
                            </S.bodyLista>
                        </S.ContainerLista>
                    }
                    {/* --------------VEICULO----------------- */}
                    {displayModal.veiculosDisplay &&
                        <S.ContainerLista>
                            <S.bodyLista>
                                {loading && !playmodal.playModalVeiculo &&
                                    <S.bodyresult>
                                        <LoadingContent />
                                    </S.bodyresult>
                                }

                                <div style={{ 'display': "flex", 'flexDirection': 'column' }} >
                                    {!loading &&
                                        <ListaVeiculos
                                            alertDelete={alertDelete}
                                            setAletDelete={setAletDelete}
                                            newStatus={newStatus}
                                            setNewStatus={setNewStatus}
                                            setRefDelet={setRefDelet}
                                            pesqVeiXcliente={PesqVeiXcliente}
                                            PesqVeiculoPlaca={PesqVeiculoPlaca}
                                        />
                                    }
                                    {playmodal.playModalVeiculo &&
                                        <ModalVeiculo
                                            FecharModal={FecharModal}
                                            Lupa={true}
                                            pesqIDveiculo={pesqIDveiculo}
                                            PesqVeiculoPlaca={PesqVeiculoPlaca}
                                            EditarSelect={EditarSelect}
                                        />
                                    }
                                </div>
                            </S.bodyLista>
                        </S.ContainerLista>
                    }

                    {/* -------------EVENTO------------------------ */}
                    {displayModal.eventoDisplay &&
                    <EVENTOS
                    alertDelete={alertDelete}
                    setAletDelete={setAletDelete}
                    />
                    }

                    {/* -------- EVENTO ORÇAMENTOS PAGAMENTOS----- */}
                    {displayModal.orcamentoDisplay &&
                        <S.ContainerLista>
                            <S.bodyLista>
                                {loading && <>
                                    <S.bodyresult>
                                        <LoadingContent />
                                    </S.bodyresult>

                                    <ListaEventos
                                        alertDelete={alertDelete}
                                        setAletDelete={setAletDelete}
                                        newStatus={newStatus}
                                        setNewStatus={setNewStatus}
                                        setRefDelet={setRefDelet}
                                        PesqEventoCod={PesqEventoCod}
                                        listaBusca={listaEvento}
                                    />

                                    <ModalOrcamento
                                        FecharModal={FecharModal}
                                        PesqVeiculoPlaca={PesqVeiculoPlaca}
                                    />
                                </>}
                            </S.bodyLista>
                        </S.ContainerLista>
                    };
                    
                    {/* -------------USUARIO----------------- */}
                    <Usuario
                        alertDelete={alertDelete}
                        BuscaTodosUsuarios={BuscaTodosUsuarios}
                        ExcluirEste={ExcluirEste}
                        FecharAlerte={FecharAlerte}
                        FecharModal={FecharModal}
                        Play_Modal_Add={Play_Modal_Add}
                        setAletDelete={setAletDelete}
                        setNewStatus={setNewStatus}
                        setRefDelet={setRefDelet}
                    />

                    {/* -------------VISTORIA----------------- */}
                    {displayModal.vistoriaDisplay &&
                        <>
                            <S.ContainerLista>

                                <S.VistoriaModal>
                                    <div style={{ display: "flex", overflow: "auto", flexDirection: "column" }}>
                                        {/* <Geolocalizacao/> */}
                                        <CameraWeb />
                                    </div>
                                </S.VistoriaModal>
                            </S.ContainerLista>
                        </>}

                    {/* -------------CONTA----------------- */}
                    {displayModal.contaDisplay &&
                        <S.ContainerLista>
                            <S.bodyLista>
                                {loading && !playmodal.playModalUsuario && <>
                                    <S.bodyresult>
                                        <LoadingContent />
                                    </S.bodyresult>
                                </>}

                                {!loading &&
                                    <div style={{ 'display': "flex", 'flexDirection': 'column' }}>
                                        {playmodal.playModalUsuario &&
                                            <ModalUsuario
                                                FecharModal={FecharModal}
                                                playModal_Add={Play_Modal_Add}
                                            />
                                        }
                                    </div>
                                }
                            </S.bodyLista>
                        </S.ContainerLista>
                    }

                    {/* //---------2------------------ */}
                    {displayModal.clienteDisplay &&
                        <S.ContainerLista>
                            <ListaBanco
                                alertDelete={alertDelete}
                                setAletDelete={setAletDelete}
                                newStatus={newStatus}
                                setNewStatus={setNewStatus}
                                setRefDelet={setRefDelet}
                            />
                            <ModalBanco />
                        </S.ContainerLista>
                    }

                </S.body2>
            </S.body>

            <Footer />
        </S.App>
    )
}
export default Add;